import axios from 'axios';
import store from '@/store';
import { getStorage } from '@/utils/storage';

// 用来下载文件
export const file = axios.create({
  baseURL: '/api',
  timeout: 1000 * 10,
});

// 请求拦截器
file.interceptors.request.use((config) => {
  config.responseType = 'blob';
  config.headers.Authorization = getStorage('token');
  return config;
});

// 响应拦截器
file.interceptors.response.use((response): any => {
  // 查找 filename="**" 字符串，其中 ** 表示为任意字符串，否则以最先匹配的双引号为结束引号
  const matched = response.headers['content-disposition'].match(/filename="[^"]*"/) || [];
  const fileNameStr = matched[0] || '';
  return { blob: response.data, filename: fileNameStr.slice(10, -1) };
}, (error) => {
  store.commit('common/setToast', { visible: true, text: '下载失败' });
  return  Promise.reject(error);
});
